import React from 'react';
// The App component's contents are currently a placeholder — please update this file first for a new design / component!
import { SalesPage } from './components/SalesPage';
export function App() {
  return <SalesPage data-id="element-0" />;
}